import React, { useState, useEffect } from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreSelect from "../../../app/core/components/CoreSelect/CoreSelect";
import { useSelector } from "react-redux";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { isCodiceFiscaleValid } from "../../../utils/functions/form";
import { toast } from "react-toastify";
import { ROLE } from "../../../utils/constants/profiles";

const FormNucleo = ({
  dataChildren,
  dataFamily,
  close,
  onCreateFamily,
  onCreateChildren,
  isLoading,
  userId,
}) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const role = useSelector((state) => state.app.role);

  const [formData, setFormData] = useState({
    nome: "",
    cognome: "",
    codiceFiscale: "",
  });
  const [familyForm, setFamilyForm] = useState({
    redditoBasso: "",
    stessoNucleo: "",
    mantenimento: "",
  });
  const [childrenForm, setChildrenForm] = useState({
    disabilita: "",
    reddito: "",
  });
  const [select, setSelect] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const parentela = ["Familiare", "Figlio/a"];

  useEffect(() => {
    if (dataChildren) {
      setFormData({
        nome: dataChildren.Name,
        cognome: dataChildren.Surname,
        codiceFiscale: dataChildren.CodiceFiscale,
      });
      setSelect("Figlio/a");
      setChildrenForm({
        disabilita: dataChildren.Disabilita,
        reddito: dataChildren.Reddito,
      });
    }
  }, [dataChildren]);

  useEffect(() => {
    if (dataFamily) {
      setFormData({
        nome: dataFamily.Name,
        cognome: dataFamily.Surname,
        codiceFiscale: dataFamily.CodiceFiscale,
      });
      setSelect("Familiare");
      setFamilyForm({
        redditoBasso: dataFamily.RedditoBasso,
        stessoNucleo: dataFamily.StessoNucleo,
        mantenimento: dataFamily.Mantenimento,
      });
    }
  }, [dataFamily]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValidationErrors({});
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    const error = {};
    if (name === "codiceFiscale") {
      if (Number.isInteger(value)) return;
      const uppercasedValue = value.toUpperCase();
      if (!isCodiceFiscaleValid(uppercasedValue)) {
        error.codiceFiscale = "Codice fiscale non valido";
        setValidationErrors(error);
      } else {
        setValidationErrors({});
      }
    }
  };

  const handleChangeFamily = (name, value) => {
    setFamilyForm((prevFamilyForm) => ({
      ...prevFamilyForm,
      [name]: value,
    }));
  };

  const handleChangeChildren = (name, value) => {
    setChildrenForm((prevChildreForm) => ({
      ...prevChildreForm,
      [name]: value,
    }));
  };

  const handleSelectParentela = (event) => {
    setSelect(event.target.value);
  };

  const handleSubmitFamily = (e) => {
    e.preventDefault();
    setValidationErrors({});
    const errors = {};
    if (!formData.nome || formData.nome === "") {
      errors.nome = "Inserire nome";
    }
    if (!formData.cognome || formData.cognome === "") {
      errors.cognome = "Inserire cognome";
    }
    if (!formData.codiceFiscale || formData.codiceFiscale === "") {
      errors.codiceFiscale = "Inserire codice fiscale";
    }
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    const bodyFamily = {
      Name: formData.nome,
      Surname: formData.cognome,
      CodiceFiscale: formData.codiceFiscale,
      RedditoBasso: familyForm.redditoBasso,
      StessoNucleo: familyForm.stessoNucleo,
      Mantenimento: familyForm.mantenimento,
    };

    if (role !== ROLE.USER) {
      bodyFamily.userId = userId;
    }

    onCreateFamily(bodyFamily).then((res) => {
      if (res.data.Result === 1) {
        close();
        toast.success("Familiare creato");
      } else {
        toast.error("Errore: " + res.data.Exception);
      }
    });
  };

  const handleSubmitChildren = (e) => {
    e.preventDefault();
    setValidationErrors({});
    const errors = {};
    if (!formData.nome || formData.nome === "") {
      errors.nome = "Inserire nome";
    }
    if (!formData.cognome || formData.cognome === "") {
      errors.cognome = "Inserire cognome";
    }
    if (!formData.codiceFiscale || formData.codiceFiscale === "") {
      errors.codiceFiscale = "Inserire codice fiscale";
    }
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    const bodyChildren = {
      Name: formData.nome,
      Surname: formData.cognome,
      CodiceFiscale: formData.codiceFiscale,
      Disabilita: childrenForm.disabilita,
      Reddito: childrenForm.reddito,
    };

    if (role !== ROLE.USER) {
      bodyChildren.userId = userId;
    }

    onCreateChildren(bodyChildren).then((res) => {
      if (res.data.Result === 1) {
        close();
        toast.success("Figlio/a creato");
      } else {
        toast.error("Errore: " + res.data.Exception);
      }
    });
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <h3>Crea un nuovo membro del nucleo familiare</h3>
      <FormGroup className=" w-2/4">
        <CoreInputField
          required={true}
          className="mt-6"
          label="Nome"
          name="nome"
          value={formData.nome}
          onChange={handleInputChange}
          error={Boolean(validationErrors.nome)}
          helperText={validationErrors.nome}
        />
        <CoreInputField
          required={true}
          className="mt-6"
          label="Cognome"
          name="cognome"
          value={formData.cognome}
          onChange={handleInputChange}
          error={Boolean(validationErrors.cognome)}
          helperText={validationErrors.cognome}
        />
        <CoreInputField
          required={true}
          className="mt-6"
          label="Codice Fiscale"
          name="codiceFiscale"
          value={formData.codiceFiscale}
          onChange={handleInputChange}
          error={Boolean(validationErrors.codiceFiscale)}
          helperText={validationErrors.codiceFiscale}
        />
      </FormGroup>
      <FormGroup className="mt-10 w-2/4">
        <CoreSelect
          required={true}
          label="Seleziona parentela"
          items={parentela.map((el) => el)}
          onChange={handleSelectParentela}
          value={select}
        />
      </FormGroup>
      {select === "Familiare" && (
        <FormGroup className="mt-8 w-3/4">
          <div className="flex space-x-6 items-center">
            <p style={{ color: colorPrimary }} className="font-bold w-9/12">
              Ha percepito un reddito inferiore a € 2841,00 lordi?
            </p>

            <div className="flex justify-end font-bold w-3/12">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={familyForm.redditoBasso === true}
                    onChange={(e) =>
                      handleChangeFamily("redditoBasso", e.target.checked)
                    }
                  />
                }
                label="Si"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={familyForm.redditoBasso === false}
                    onChange={(e) =>
                      handleChangeFamily("redditoBasso", !e.target.checked)
                    }
                  />
                }
                label="No"
              />
            </div>
          </div>
          <div className="flex space-x-6 items-center">
            <p style={{ color: colorPrimary }} className="font-bold w-9/12">
              Il familiare è nello stesso nucleo familiare?
            </p>

            <div className="flex justify-end font-bold w-3/12">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={familyForm.stessoNucleo === true}
                    onChange={(e) =>
                      handleChangeFamily("stessoNucleo", e.target.checked)
                    }
                  />
                }
                label="Si"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={familyForm.stessoNucleo === false}
                    onChange={(e) =>
                      handleChangeFamily("stessoNucleo", !e.target.checked)
                    }
                  />
                }
                label="No"
              />
            </div>
          </div>
          <div className="flex space-x-6 items-center">
            <p style={{ color: colorPrimary }} className="font-bold w-9/12">
              Se non è nello stesso nucleo familiare, contribuisci al suo
              mantenimento?
            </p>

            <div className="flex justify-end font-bold w-3/12">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={familyForm.mantenimento === true}
                    onChange={(e) =>
                      handleChangeFamily("mantenimento", e.target.checked)
                    }
                  />
                }
                label="Si"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={familyForm.mantenimento === false}
                    onChange={(e) =>
                      handleChangeFamily("mantenimento", !e.target.checked)
                    }
                  />
                }
                label="No"
              />
            </div>
          </div>
          <div className="mt-10 text-center">
            <CoreButton
              disabled={isLoading}
              onClick={handleSubmitFamily}
              className={"btn-round"}
              variant="contained"
              testo={isLoading ? "attendere" : "Crea"}
            />
          </div>
        </FormGroup>
      )}
      {select === "Figlio/a" && (
        <FormGroup className="mt-8 w-3/4">
          <div className="flex items-center space-x-8">
            <p style={{ color: colorPrimary }} className="font-bold w-9/12">
              È una persona con disabilità (secondo legge 104)?
            </p>

            <div className="flex justify-end font-bold w-3/12">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={childrenForm.disabilita === true}
                    onChange={(e) =>
                      handleChangeChildren("disabilita", e.target.checked)
                    }
                  />
                }
                label="Si"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={childrenForm.disabilita === false}
                    onChange={(e) =>
                      handleChangeChildren("disabilita", !e.target.checked)
                    }
                  />
                }
                label="No"
              />
            </div>
          </div>
          <div className="flex items-center space-x-6">
            <p style={{ color: colorPrimary }} className="font-bold w-9/12">
              È una persona con una propria fonte di reddito?
            </p>

            <div className="flex justify-end ite font-bold w-3/12">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={childrenForm.reddito === true}
                    onChange={(e) =>
                      handleChangeChildren("reddito", e.target.checked)
                    }
                  />
                }
                label="Si"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={childrenForm.reddito === false}
                    onChange={(e) =>
                      handleChangeChildren("reddito", !e.target.checked)
                    }
                  />
                }
                label="No"
              />
            </div>
          </div>
          <div className="mt-10 text-center">
            <CoreButton
              disabled={isLoading}
              onClick={handleSubmitChildren}
              className={"btn-round"}
              variant="contained"
              testo={isLoading ? "attendere" : "Crea"}
            />
          </div>
        </FormGroup>
      )}
    </div>
  );
};

export default FormNucleo;
